module.exports = __webpack_public_path__ + "static/media/fz_schdviewrobotconfirmed_pt_PT.f5f658a5.png";